const ToolsData=[
    {
        duration:1000,
        img: "/images/github-removebg-preview.png",
        name: "Github"
      },
      {
        duration:1300,
        img: "/images/vscode-removebg-preview.png",
        name: "VScode"
      },
      {
        duration:1600,
        img: "/images/vercel-removebg-preview (1).png",
        name: "Vercel"
      },
      {
        duration:1900,
        img: "/images/colab-removebg-preview.png",
        name: "Colab"
      },
      {
        duration:2200,
        img: "/images/eclipse-removebg-preview.png",
        name: "Eclipse IDE"
      },

    ];
    export default ToolsData;